<template>
  <div class="box2">
    <div class="wrapper">
      <pageTitle
        title="技术全程赋能<br/>AI应用方案助力职场提升"
        text="AI技术正在改变传统测试模式，提升效率与可靠性。课程涵盖应用AI解决方案，助你脱颖而出"
        titColor="#86909C"
      />
      
    </div>
    <div class="subject-content">
      <div class="left-box">
        <img src="../../../assets/coursePage/softwareTest/box2/icon.png" />
        <p class="top">软件测试</p>
        <p class="bottom">测试新纪元</p>
      </div>
      <div class="right-box">
        <div class="item-box">
          <div class="title">AI+功能测试方案</div>
          <div class="text"><a>AI助力快速分析测试结果，让测试</a><span>工作更高效</span></div>
          <div class="btn-box">需求分析提取｜完善测试计划｜提炼测试点</div>
        </div>
        <div class="item-box">
          <div class="title">AI+代码编程方案</div>
          <div class="text"><a>AI编程助手让你的编程学习与实践</a><span>更加顺畅</span></div>
          <div class="btn-box">代码注释｜代码解释｜代码纠错｜代码生成</div>
        </div>
        <div class="item-box">
          <div class="title">AI+UI自动化测试方案</div>
          <div class="text">智能识别：<a>AI智能操作</a><span>减少人力成本</span></div>
          <div class="text">跨平台兼容：<a>确保UI测试</a><span>全面覆盖</span></div>
          <div class="btn-box">代码纠错｜代码生成</div>
        </div>
        <div class="item-box">
          <div class="title">AI+性能测试方案</div>
          <div class="text">智能场景模拟：<span>发现潜在性能问题</span></div>
          <div class="text">关键业务优化：<span>助力产品性能提升</span></div>
          <div class="btn-box">性能场景分析｜性能测试用例设计｜性能代码生成</div>
        </div>
        <div class="item-box">
          <div class="title">AI+接口自动化测试方案</div>
          <div class="text">智能接口识别：<a>AI快速识别接口确保</a><span>稳定可靠</span></div>
          <div class="text">大型项目案例：<a>分享成功应用，展现AI测试</a><span>实用性</span></div>
          <div class="btn-box">接口用例设计｜接口代码纠错｜接口代码生成</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
      },
      list: [
        {
          title: "岗位价值认知较晚",
          titleSpec: "软件测试渐受重视",
          p: "在早期国内市场，很多软件企业都存在着重开发、轻测试的现象，甚至有很多互联网和软件企业都没有专门的测试岗位，这导致一款产品上线之后问题频发，从而丧失用户群体及经济损失。比如2019年1月20日凌晨，某多电商平台出现优惠券Bug，用户通过扫码领取大量100元无门槛优惠券，直接导致200亿经济损失。",
        },
        {
          title: "软件行业关键阶段",
          titleSpec: "未来发展潜力巨大",
          p: "一方面，随着企业近年来对客户体验高度重视，因此相当注重产品质量；另一方面，产品质量的把控需要专业的测试人员，而且软件涉及各行各业，为了保证软件产品质量及用户体验，各行业公司对于软件测试的岗位需求越来越旺盛。",
        },
        {
          title: "国家重点发展方向",
          titleSpec: "相关政策大力推动",
          p: "2021年12月《“十四五”软件和信息技术服务业发展规划》发布，阐明了软件测试领域的重要性，论述了软件测试从根本上提升我国软件质量水平的决定性作用。工业和信息化部再次明确道出：未来将在七大方向上支持软件高质量发展，促进软件测试领域的大发展！",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box2 {
  width: 100%;
  box-sizing: border-box;
  font-family: PingFangSC, PingFang SC;
  padding: 80px 0;
  .wrapper {
    padding: 0 32px;
  }
  .subject-content {
    margin-top: 50px;
    position: relative;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    .left-box {
      margin-top: 92px;
      box-sizing: border-box;
      position: relative;
      padding: 164px 15px;
      width: 66px;
      height: 828px;
      background: linear-gradient( 224deg, #3D8EFD 0%, #37ABFF 100%);
      border-radius: 10px;
      img {
        position: absolute;
        top: -92px;
        left: -16px;
        display: block;
        width: 112px;
      }
      p {
        font-weight: 600;
        font-size: 36px;
        color: #FFFFFF;
        line-height: 50px;
        text-align: center;
      }
      .bottom {
        margin-top: 50px;
      }
    }
    .right-box {
      .item-box {
        margin-bottom: 24px;
        padding-left: 20px;
        width: 600px;
        box-sizing: border-box;
        .title {
          font-weight: 600;
          font-size: 30px;
          color: #3E8EFE;
          line-height: 48px;
          text-align: left;
        }
        .text {
          font-weight: 600;
          font-size: 26px;
          color: #1F375F;
          line-height: 40px;
          text-align: left;
          span {
            font-weight: 400;
            background: linear-gradient(to right, #165DFF, #3196FF); 
            -webkit-background-clip: text; // 只在文字区域显示背景
            -webkit-text-fill-color: transparent;
          }
          a {
            font-weight: 400;
            color: #1F375F;
          }
        }
        .btn-box {
          font-weight: 400;
          font-size: 26px;
          color: #86909C;
          line-height: 40px;
          text-align: left;
        }
      }
      .item-box:nth-child(2n) {
        background: #F4FBFF;
        border-radius: 16px;
        padding: 18px 0 16px 20px;
      }
     .item-box:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
